module.exports = __webpack_public_path__ + "img/ic_new-media.f5410bdf.png";